import YoutubeVideoPlayer from '@cohort/components-xps/components/apps/youtube/YoutubeVideoPlayer';
import type {YoutubeCommentTriggerStruct} from '@cohort/shared/apps/youtube/triggers/comment';
import serializeDataAttributes from '@cohort/shared-frontend/utils/serializeDataAtttributes';
import type {DetailsComponentProps} from '@cohort/wallet/apps/TriggerIntegration';

const YoutubeCommentTriggerIntegrationDetailsComponent: React.FC<
  DetailsComponentProps<YoutubeCommentTriggerStruct>
> = ({config, stepId, triggerId}) => (
  <div
    className="w-full"
    {...serializeDataAttributes({
      'step-id': stepId,
      'trigger-id': triggerId,
    })}
  >
    <YoutubeVideoPlayer videoId={config.videoId} />
  </div>
);

export default YoutubeCommentTriggerIntegrationDetailsComponent;
